<template>
  <el-dialog :title="$t('propertyCompanyManage.edit')" :visible.sync="visible" width="40%" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-form-item :label="$t('propertyCompanyManage.name')" prop="name" required>
        <el-input v-model="formData.name" />
      </el-form-item>
      <el-form-item :label="$t('propertyCompanyManage.address')" prop="address" required>
        <el-input v-model="formData.address" />
      </el-form-item>
      <el-form-item :label="$t('propertyCompanyManage.tel')" prop="tel" required>
        <div>
          <el-input v-model="formData.tel" />
          <div style="color: #909399; font-size: 12px; line-height: 1.5; margin-top: 5px; text-align: left;">
            请填写真实手机号，此手机号将作为你登录后台的默认账号
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('propertyCompanyManage.corporation')" prop="corporation" required>
        <el-input v-model="formData.corporation" />
      </el-form-item>
      <el-form-item :label="$t('propertyCompanyManage.foundingTime')" prop="foundingTime" required>
        <el-date-picker 
          v-model="formData.foundingTime" 
          type="date" 
          value-format="yyyy-MM-dd" 
          style="width: 100%" 
          placeholder="请选择成立日期" />
      </el-form-item>
      <el-form-item :label="$t('propertyCompanyManage.landmark')" prop="nearByLandmarks" required>
        <el-input v-model="formData.nearByLandmarks" />
      </el-form-item>
    </el-form>
    <div style="color: #909399; font-size: 12px; line-height: 1.5; margin-bottom: 20px; padding-left: 120px; text-align: left;">
      如需修改密码请登录相对应后台进行修改
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateProperty } from '@/api/store/propertyCompanyManageApi'

export default {
  name: 'EditPropertyCompany',
  data() {
    return {
      visible: false,
      formData: {},
      rules: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '地址不能为空', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        corporation: [
          { required: true, message: '公司法人不能为空', trigger: 'blur' }
        ],
        foundingTime: [
          { required: true, message: '成立日期不能为空', trigger: ['blur', 'change'] }
        ],
        nearByLandmarks: [
          { required: true, message: '地标不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.visible = true
      this.formData = { ...row }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await updateProperty(this.formData)
        this.$message.success(this.$t('propertyCompanyManage.editSuccess'))
        this.$emit('success')
        this.visible = false
      } catch (error) {
        if (error.message) {
          this.$message.error(error.message)
        }
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

